import { createPortal } from "react-dom";

import { cn } from "@/shared/lib/css";

type NavBarContainerProps = {
  children: React.ReactNode;
  navMargin?: string;
};

export const NavBarContainer = ({
  children,
  navMargin = "bottom-3",
}: NavBarContainerProps) => {
  return createPortal(
    <nav
      className={cn(
        "fixed z-40 left-1/2 -translate-x-1/2 w-full max-w-sm",
        "h-16 px-2 rounded-full",
        "backdrop-blur-xl bg-black/40 border border-white/20",
        "shadow-2xl shadow-black/50",
        navMargin,
      )}
    >
      <div className="flex items-center justify-around h-full">{children}</div>
    </nav>,
    document.body,
  );
};
